
import request from '@/utils/request'
import requestJson from "@/utils/requestJson"


// 报价单列表
export function quotationGetList(data) {
    return requestJson({
        url: '/admin/order_offer/getList',
        method: 'get',
        params: data
    })
}

// 报价单详情
export function quotationGetDetail(data) {
    return requestJson({
        url: '/admin/order_offer/getDetail',
        method: 'get',
        params: data
    })
}

// 新增报价单
export function quotationAdd(data) {
    return requestJson({
        url: '/admin/order_offer/add',
        method: 'post',
        data
    })
}

// 修改报价单
export function quotationUp(data) {
    return requestJson({
        url: '/admin/order_offer/up',
        method: 'post',
        data
    })
}

// 删除报价单
export function quotationDel(data) {
    return requestJson({
        url: '/admin/order_offer/del',
        method: 'get',
        params: data
    })
}



// WEBPACK FOOTER //
// ./src/api/quotation.js